/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import 'alpinejs'
window.moment = require('moment');
window._ = require('lodash');
window.toastr = require('toastr');
// window.mediumZoom = require('medium-zoom').default;
window.svgPanZoom = require('svg-pan-zoom');

require('../bootstrap');
require('../plugins');
require('select2');
require('jquery-validation');
require('./includes/juxtapose')
require('./scdi');
require('./includes/select-custom');

window.getUrlParameter = function(sParam) {
	let sPageURL = window.location.search.substring(1),
		sURLVariables = sPageURL.split('&'),
		sParameterName, i;

	for (i = 0; i < sURLVariables.length; i++) {
		sParameterName = sURLVariables[i].split('=');

		if (sParameterName[0] === sParam) {
			return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
		}
	}
	return '';
};
